import { render, staticRenderFns } from "./ShopBlock.vue?vue&type=template&id=ee2ea982&scoped=true"
import script from "./ShopBlock.vue?vue&type=script&lang=js"
export * from "./ShopBlock.vue?vue&type=script&lang=js"
import style0 from "./ShopBlock.vue?vue&type=style&index=0&id=ee2ea982&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2ea982",
  null
  
)

export default component.exports